export default (state, action) => {
    if (typeof state === 'undefined') {
      state = {
        isFetching: true,
        data: {}
      }
    }
  
    switch (action.type) {
      case 'GET_DROP_DOWN_PENDING':
        return { isFetching: true, data: action.payload }
      case 'GET_DROP_DOWN_SUCCESS':
        return { isFetching: false, data: action.payload.data }
      case 'GET_DROP_DOWN_ERROR':
        return { isFetching: false, data: action.payload }
      default:
        return state
    }
  };